import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {InstitutionAdmin} from './institution-admin.model';
import * as InstitutionAdminActions from './institution-admin.actions';

export const institutionAdminsFeatureKey = 'institutionAdmins';

export interface State extends EntityState<InstitutionAdmin> {
  // additional entities state properties
}

export const adapter: EntityAdapter<InstitutionAdmin> = createEntityAdapter<InstitutionAdmin>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(InstitutionAdminActions.addInstitutionAdmin,
    (state, action) => adapter.addOne(action.institutionAdmin, state)
  ),
  on(InstitutionAdminActions.upsertInstitutionAdmin,
    (state, action) => adapter.upsertOne(action.institutionAdmin, state)
  ),
  on(InstitutionAdminActions.addInstitutionAdmins,
    (state, action) => adapter.addMany(action.institutionAdmins, state)
  ),
  on(InstitutionAdminActions.upsertInstitutionAdmins,
    (state, action) => adapter.upsertMany(action.institutionAdmins, state)
  ),
  on(InstitutionAdminActions.updateInstitutionAdmin,
    (state, action) => adapter.updateOne(action.institutionAdmin, state)
  ),
  on(InstitutionAdminActions.updateInstitutionAdmins,
    (state, action) => adapter.updateMany(action.institutionAdmins, state)
  ),
  on(InstitutionAdminActions.deleteInstitutionAdmin,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(InstitutionAdminActions.deleteInstitutionAdmins,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(InstitutionAdminActions.loadInstitutionAdmins,
    (state, action) => adapter.setAll(action.institutionAdmins, state)
  ),
  on(InstitutionAdminActions.clearInstitutionAdmins,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
